import React from 'react';
import { motion } from 'framer-motion';
export function ForAgencies() {
  return <section className="py-24 border-b border-stone-300" data-id="element-1009">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1010">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-1011">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-1012">
            {/* Left: Benefits grid */}
            <div className="order-2 lg:order-1" data-id="element-1013">
              <div className="grid grid-cols-2 border border-stone-300" data-id="element-1014">
                <div className="p-6 border-r border-b border-stone-300" data-id="element-1015">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-1016">
                    01
                  </p>
                  <p className="font-medium text-stone-900 mb-2" data-id="element-1017">
                    Instant Options
                  </p>
                  <p className="text-sm text-stone-600" data-id="element-1018">
                    Good/Better/Best packages in seconds
                  </p>
                </div>

                <div className="p-6 border-b border-stone-300" data-id="element-1019">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-1020">
                    02
                  </p>
                  <p className="font-medium text-stone-900 mb-2" data-id="element-1021">
                    Faster Approvals
                  </p>
                  <p className="text-sm text-stone-600" data-id="element-1022">
                    Real-time availability, no waiting
                  </p>
                </div>

                <div className="p-6 border-r border-stone-300" data-id="element-1023">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-1024">
                    03
                  </p>
                  <p className="font-medium text-stone-900 mb-2" data-id="element-1025">
                    Track Everything
                  </p>
                  <p className="text-sm text-stone-600" data-id="element-1026">
                    Holds, deadlines, deposits in one place
                  </p>
                </div>

                <div className="p-6" data-id="element-1027">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-1028">
                    04
                  </p>
                  <p className="font-medium text-stone-900 mb-2" data-id="element-1029">Win More</p>
                  <p className="text-sm text-stone-600" data-id="element-1030">
                    Less back-and-forth, higher win rate
                  </p>
                </div>
              </div>
            </div>

            {/* Right: Content */}
            <div className="order-1 lg:order-2" data-id="element-1031">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-1032">
                For Agencies
              </p>

              <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-[1.1] text-stone-900 mb-8" data-id="element-1033">
                Close groups faster
              </h2>

              <p className="text-lg text-stone-600 leading-relaxed mb-8" data-id="element-1034">
                Agencies are the lifeblood of group travel. BlockQuote gives
                them the tools to present options instantly, secure inventory,
                and win more business for their clients.
              </p>

              <ul className="space-y-4 text-stone-600" data-id="element-1035">
                <li className="flex items-start gap-3" data-id="element-1036">
                  <span className="w-1 h-1 bg-red-600 mt-2.5 flex-shrink-0" data-id="element-1037"></span>
                  <span data-id="element-1038">No more waiting days for an email reply</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1039">
                  <span className="w-1 h-1 bg-stone-400 mt-2.5 flex-shrink-0" data-id="element-1040"></span>
                  <span data-id="element-1041">Professional, branded proposals ready to forward</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1042">
                  <span className="w-1 h-1 bg-stone-400 mt-2.5 flex-shrink-0" data-id="element-1043"></span>
                  <span data-id="element-1044">
                    Clear visibility into hold expiries and deposit dates
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}